import * as jsxRuntime from "/codebuild/output/src3131767064/src/codestar-connections.eu-west-1.amazonaws.com/git-http/157612454188/eu-west-1/782e908f-6c63-401e-8448-6ef9ad0364a8/korelogic-developers/redbox-services/client/customer-v2/node_modules/react/jsx-runtime.js"
export const jsx = jsxRuntime.jsx
export const jsxs = jsxRuntime.jsxs
export const Fragment = jsxRuntime.Fragment